// @flow

import type { WizardPage, WizardPageChosenOptions } from '@chatchamp/chatchamp-types'
import {
  WIZARD_PAGE_TYPE_FILE_UPLOAD,
  WIZARD_PAGE_TYPE_GALLERY,
  WIZARD_PAGE_TYPE_INPUT,
  WIZARD_PAGE_TYPE_MULTIPLE_CHOICE,
  WIZARD_PAGE_TYPE_MULTIPLE_INPUT,
  WIZARD_PAGE_TYPE_PRODUCTS,
  WIZARD_PAGE_TYPE_RANGE,
  WIZARD_PAGE_TYPE_SINGLE_CHOICE
} from '@chatchamp/chatchamp-types'

export const EVENT_PRODUCTS_RECOMMENDED = 'products-recommended'

export type QuestionProgressBarSettings = {
  progress: number,
  items: WizardPage[]
}

export type QuestionHeaderSettings = {
  avatar: {
    imageUrl: string,
    name: string
  },
  progressBar: QuestionProgressBarSettings,
  topMessage: {
    title: string,
    description: string
  },
  showCloseButton: boolean,
  isCurrentProductsPage: boolean,
  isSortingEnabled: boolean,
  isSearchEnabled: boolean,
  optionSearchQuery: ?string
}

export type QuestionSettings = {
  header: QuestionHeaderSettings
}

export type QuestionSelection = {
  options: WizardPageChosenOptions,
  forceNextPage?: boolean
}

export const isAutoNext = (messageType: string): boolean => {
  const autoNext = [
    WIZARD_PAGE_TYPE_SINGLE_CHOICE,
    WIZARD_PAGE_TYPE_GALLERY,
    WIZARD_PAGE_TYPE_INPUT,
    WIZARD_PAGE_TYPE_MULTIPLE_INPUT
  ]
  return autoNext.includes(messageType)
}

export const isMultipleChoice = (wizardPage: WizardPage): boolean => {
  const multiples = [
    WIZARD_PAGE_TYPE_MULTIPLE_CHOICE
  ]
  return multiples.includes(wizardPage.pageType)
}

export const isProducts = (wizardPage: WizardPage): boolean => {
  return wizardPage.pageType === WIZARD_PAGE_TYPE_PRODUCTS
}

export const isInput = (wizardPage: WizardPage): boolean => {
  return wizardPage.pageType === WIZARD_PAGE_TYPE_INPUT
}

export const isRange = (wizardPage: WizardPage): boolean => {
  return wizardPage.pageType === WIZARD_PAGE_TYPE_RANGE
}

export const isFileUpload = (wizardPage: WizardPage): boolean => {
  return wizardPage.pageType === WIZARD_PAGE_TYPE_FILE_UPLOAD
}

export const isMultipleInput = (wizardPage: WizardPage): boolean => {
  return wizardPage.pageType === WIZARD_PAGE_TYPE_MULTIPLE_INPUT
}

export function scriptParameters (): any {
  const parameters = document.querySelector('#chatchamp-wizard-script')?.dataset || {}
  return {
    ...parameters,
    customerId: parameters.customer_id,
    parentUrl: parameters.parent_url,
    wizardIntegrationId: parameters.wizard_integration_id
  }
}

export function scriptParameter (name: string): any {
  const parameters = scriptParameters()
  return parameters[name]
}
